export default "__VITE_ASSET__BIZtSFtH__"